import { render, staticRenderFns } from "./CalendarDialogAddNewEvent.vue?vue&type=template&id=78520f47&scoped=true"
import script from "./CalendarDialogAddNewEvent.vue?vue&type=script&lang=js"
export * from "./CalendarDialogAddNewEvent.vue?vue&type=script&lang=js"
import style0 from "./CalendarDialogAddNewEvent.vue?vue&type=style&index=0&id=78520f47&prod&scoped=true&lang=css"
import style1 from "./CalendarDialogAddNewEvent.vue?vue&type=style&index=1&id=78520f47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78520f47",
  null
  
)

export default component.exports